module.exports = __webpack_public_path__ + "static/media/especialistas_testimonios1.2b6e5874.jpg";